/* schmorzeit-zugabe.js - Gratis-Dosen zum Aussuchen (Schmorzeit).
   Konfiguration und Hintergrund: snippets/schmorzeit-zugabe.liquid.
   Vanilla, kein Build. Prueft nach jeder Warenkorb-Aenderung (fetch auf
   /cart/add|change|update|clear), ob nicht mehr Dosen im Warenkorb liegen als
   der Warenwert erlaubt, und stellt der Auswahlseite eine kleine API bereit:
     window.SZZugabe.state()   -> Promise mit dem aktuellen Stand
     window.SZZugabe.add(id)   -> legt eine Dose dazu, wenn ein Platz frei ist
     window.SZZugabe.remove(id)-> nimmt eine Dose dieser Sorte heraus
   Jede Aenderung meldet das Ereignis "sz:zugabe" mit dem Stand im detail. */
(function () {
  'use strict';
  if (window.SZZugabe) return;

  var el = document.getElementById('sz-zugabe-config');
  if (!el) return;
  var cfg;
  try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
  if (!cfg || !cfg.giftIds || !cfg.giftIds.length) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var giftIds = cfg.giftIds.map(Number);
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var origFetch = window.fetch.bind(window);
  var busy = false;
  var again = false;
  var timer = null;
  var letzterStand = null;
  // Abgleichen lohnt nur, wenn Dosen im Warenkorb liegen oder die Auswahlseite
  // offen ist. Sonst fragt das Skript auf keiner Seite den Warenkorb ab.
  var hatDosen = cfg.imWarenkorb > 0;
  try { if (localStorage.getItem('sz-zugabe-dosen')) hatDosen = true; } catch (e) {}
  var aufAuswahl = !!document.querySelector('[data-sz-auswahl]');
  function noetig() { return hatDosen || aufAuswahl; }

  function aktivJetzt() {
    if (!cfg.aktiv) return false;
    var ende = Date.parse(cfg.ende || '');
    return !(ende && Date.now() > ende);
  }

  function isGift(item) { return giftIds.indexOf(item.variant_id) !== -1; }

  // Gratisartikel anderer Aktionen, z. B. die Kite-Leberwurst. Sie stehen mit
  // ihrem normalen Preis im Warenkorb und werden erst per Rabatt 0 €, duerfen
  // den Warenwert fuer die Dosen also nicht erhoehen.
  // Massgeblich ist nur, ob die Zeile wirklich 0 € kostet. Kites Markierung
  // _free_product allein reicht nicht: Sie kann an Zeilen haengen, die voll
  // berechnet werden (gesehen am 16.10. bei 4x Fruehstuecksfleisch).
  function istFremdesGeschenk(item) {
    return item.original_line_price > 0 && item.final_line_price === 0;
  }

  function json(url, body) {
    var opts = { headers: { Accept: 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    // Nie ewig haengen: nach 10 s abbrechen, sonst blockiert die Warteschlange
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var uhr = ctrl ? setTimeout(function () { ctrl.abort(); }, 10000) : null;
    if (ctrl) opts.signal = ctrl.signal;
    // origFetch, damit eigene Aenderungen keinen neuen Abgleich ausloesen
    var NICHT_ERREICHBAR = 'Der Warenkorb antwortet gerade nicht. Bitte versuch es noch einmal.';
    return origFetch(ROOT + url, opts).then(function (r) {
      clearTimeout(uhr);
      // Keine JSON-Antwort (Fehlerseite, Zeitueberschreitung): verstaendliche Meldung
      return r.json().then(function (data) {
        if (!r.ok) throw new Error((data && (data.description || data.message)) || NICHT_ERREICHBAR);
        return data;
      }, function () {
        throw new Error(NICHT_ERREICHBAR);
      });
    }, function () {
      clearTimeout(uhr);
      throw new Error(NICHT_ERREICHBAR);
    });
  }

  // Stand aus einem Warenkorb ableiten
  function stand(cart) {
    var wert = 0;
    var gewaehlt = 0;
    var jeSorte = {};
    cart.items.forEach(function (it) {
      if (isGift(it)) {
        gewaehlt += it.quantity;
        jeSorte[it.variant_id] = (jeSorte[it.variant_id] || 0) + it.quantity;
      } else if (!istFremdesGeschenk(it) && !it.gift_card) {
        // Warenwert vor Rabatten, ohne Gratisartikel anderer Aktionen und
        // ohne Gutscheine (auch der Staffelrabatt zaehlt sie nicht)
        wert += it.original_line_price;
      }
    });
    var erlaubt = 0;
    var naechste = null;
    if (aktivJetzt()) {
      cfg.tiers.forEach(function (t) {
        if (wert >= t) erlaubt += 1;
        else if (naechste === null) naechste = t;
      });
    }
    return {
      aktiv: aktivJetzt(),
      wert: wert,
      erlaubt: erlaubt,
      gewaehlt: gewaehlt,
      frei: Math.max(0, erlaubt - gewaehlt),
      naechsteAb: naechste,
      fehlt: naechste === null ? 0 : naechste - wert,
      tiers: cfg.tiers.slice(),
      jeSorte: jeSorte
    };
  }

  // Andere Tabs erfahren ueber localStorage, dass Dosen im Warenkorb liegen.
  // Sonst wuerde ein Tab, der vorher geladen wurde, nie abgleichen.
  var MERK_DOSEN = 'sz-zugabe-dosen';
  function melden(s) {
    letzterStand = s;
    hatDosen = s.gewaehlt > 0;
    try {
      if (hatDosen) localStorage.setItem(MERK_DOSEN, String(Date.now()));
      else localStorage.removeItem(MERK_DOSEN);
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('sz:zugabe', { detail: s }));
  }

  var MERK = 'sz-zugabe-hinweis';
  var MERK_RELOAD = 'sz-zugabe-reload';
  // Hoechstens zwei Neuladungen je Minute, damit ein Warenkorb, der sich nicht
  // aendern laesst, die Warenkorbseite nicht endlos neu laedt.
  function darfNeuLaden() {
    try {
      var r = JSON.parse(sessionStorage.getItem(MERK_RELOAD) || '[]').filter(function (t) { return Date.now() - t < 60000; });
      if (r.length >= 2) return false;
      r.push(Date.now());
      sessionStorage.setItem(MERK_RELOAD, JSON.stringify(r));
      return true;
    } catch (e) { return false; }
  }
  function refreshUi(text) {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    if (/\/cart\/?$/.test(location.pathname) && darfNeuLaden()) {
      // Auf der Warenkorbseite wird neu geladen, der Hinweis kommt danach
      try { if (text) sessionStorage.setItem(MERK, text); } catch (e) {}
      location.reload();
      return;
    }
    if (text) hinweis(text);
  }

  function euro(cents) {
    return (Math.round(cents) / 100).toFixed(2).replace('.', ',').replace(',00', '') + ' €';
  }

  // Eine dauerhafte, leere Live-Region: Screenreader lesen nur Aenderungen vor
  var live = null;
  var liveTimer = null;
  function hinweis(text) {
    if (!live) {
      live = document.createElement('div');
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('data-sz-zugabe-toast', '');
      live.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;' +
        'background:#191616;color:#F5F1EA;padding:12px 18px;border-radius:4px;max-width:calc(100vw - 32px);' +
        'font:600 14px/1.45 var(--body-font-family,Montserrat),sans-serif;box-shadow:0 8px 24px rgba(0,0,0,.25);display:none';
      document.body.appendChild(live);
    }
    live.textContent = '';
    live.style.display = 'block';
    setTimeout(function () { live.textContent = text; }, 50);
    clearTimeout(liveTimer);
    liveTimer = setTimeout(function () { live.style.display = 'none'; live.textContent = ''; }, 7000);
  }

  function dosen(n) { return n === 1 ? '1 Gratis-Dose' : n + ' Gratis-Dosen'; }

  // Zu viele Dosen: die zuletzt gewaehlten herausnehmen. Shopify listet die
  // neuesten Zeilen zuerst, also wird von vorne gekuerzt.
  function abgleichen(cart) {
    var s = stand(cart);
    var zuViel = s.gewaehlt - s.erlaubt;
    if (zuViel <= 0) { melden(s); return Promise.resolve(s); }
    var weg = zuViel;
    var updates = {};
    cart.items.forEach(function (it) {
      if (zuViel <= 0 || !isGift(it)) return;
      var n = Math.min(it.quantity, zuViel);
      updates[it.key] = it.quantity - n;
      zuViel -= n;
    });
    return json('cart/update.js', { updates: updates }).then(function (neu) {
      var n = stand(neu);
      melden(n);
      // Nichts herausgenommen (etwa weil der Shop die Aenderung abgelehnt hat):
      // keine Meldung und kein Neuladen
      if (n.gewaehlt >= s.gewaehlt) return n;
      var text;
      if (!n.aktiv) text = 'Die Schmorzeit ist vorbei, die Gratis-Dosen haben wir aus dem Warenkorb genommen.';
      else if (n.erlaubt === 0) text = 'Dein Warenwert liegt unter ' + euro(cfg.tiers[0]) + ', deshalb haben wir ' + (weg === 1 ? 'die Gratis-Dose' : 'die Gratis-Dosen') + ' herausgenommen.';
      else text = 'Dein Warenwert liegt jetzt unter ' + euro(cfg.tiers[n.erlaubt]) + '. ' + (n.erlaubt === 1 ? 'Es bleibt ' : 'Es bleiben ') + dosen(n.erlaubt) + ', ' + (weg === 1 ? 'die zuletzt gewählte haben wir herausgenommen.' : 'die zuletzt gewählten haben wir herausgenommen.');
      refreshUi(text);
      return n;
    });
  }

  // Alle Aenderungen laufen nacheinander, nie parallel. So kann ein schneller
  // Doppelklick auf zwei Karten keinen Platz doppelt vergeben.
  var kette = Promise.resolve();
  var inArbeit = 0;
  var aenderungen = 0;
  function nacheinander(fn) {
    inArbeit++;
    aenderungen++;
    var p = kette.then(fn, fn);
    kette = p.then(function () { inArbeit--; }, function () { inArbeit--; });
    return p;
  }

  var fehlerNochmal = false;
  function sync() {
    if (busy) { again = true; return kette; }
    busy = true;
    return nacheinander(function () {
      return json('cart.js').then(abgleichen);
    })
      .catch(function (err) {
        if (window.console) console.warn('[Schmorzeit-Zugabe]', err);
        // Einmal nach 2 Sekunden erneut versuchen (z. B. nach 429 vom Shop)
        if (!fehlerNochmal) { fehlerNochmal = true; setTimeout(function () { schedule(true); }, 2000); }
      })
      .then(function (s) {
        if (s) fehlerNochmal = false;
        busy = false;
        if (again) { again = false; schedule(); }
      });
  }

  // force: nach einer Warenkorb-Aenderung immer abgleichen, auch wenn dieser
  // Tab noch nichts von Dosen weiss (sie koennen in einem anderen Tab dazugekommen sein)
  function schedule(force) {
    if (!force && !noetig()) return;
    clearTimeout(timer);
    timer = setTimeout(function () { timer = null; sync(); }, 300);
  }

  function istCartUrl(input) {
    var url = typeof input === 'string' ? input : (input && (input.href || input.url)) || '';
    return CART_RE.test(String(url));
  }

  // Legt jemand eine Dose an der Auswahlseite vorbei in den Warenkorb, wird
  // ab dann abgeglichen
  function enthaeltDose(body) {
    var t = typeof body === 'string' ? body : '';
    if (!t && body && typeof FormData !== 'undefined' && body instanceof FormData) {
      try { t = Array.from(body.values()).join(' '); } catch (e) {}
    }
    return giftIds.some(function (id) { return t.indexOf(String(id)) !== -1; });
  }

  window.fetch = function (input, init) {
    var p = origFetch(input, init);
    if (istCartUrl(input)) {
      if (init && enthaeltDose(init.body)) hatDosen = true;
      p.then(function () { schedule(true); }, function () {});
    }
    return p;
  };

  // Apps, die per XHR (jQuery & Co.) den Warenkorb aendern, ebenfalls abfangen
  var xOpen = XMLHttpRequest.prototype.open;
  var xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__szCart = istCartUrl(url);
    return xOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__szCart && enthaeltDose(body)) hatDosen = true;
    if (this.__szCart) this.addEventListener('loadend', function () { schedule(true); });
    return xSend.apply(this, arguments);
  };

  function ruhig() { return !busy && !again && !timer; }

  // Wartet, bis kein Abgleich mehr offen oder geplant ist (hoechstens 8 s)
  function warteBisRuhig() {
    var bis = Date.now() + 8000;
    return new Promise(function (fertig) {
      (function pruefen() {
        if (Date.now() > bis) return fertig();
        if (ruhig()) return kette.then(function () { ruhig() ? fertig() : setTimeout(pruefen, 100); });
        setTimeout(pruefen, 100);
      })();
    });
  }

  // Ist noch ein Abgleich offen, wartet der Weg zur Kasse darauf. Sonst koennte
  // jemand die Menge senken und sofort auf "Zur Kasse" klicken. Danach geht es
  // genau den Weg weiter, den der Klick gehen wollte: Formular absenden (mit
  // Notiz und Attributen) oder dem Link folgen.
  // Express-Buttons (PayPal, Apple Pay) laufen in eigenen Frames und lassen
  // sich so nicht abfangen. Dort gilt der Stand vom letzten Abgleich.
  var weiterleiten = false;
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (!t || weiterleiten || (ruhig() && !noetig())) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    // Vor der Kasse immer einmal frisch abgleichen
    clearTimeout(timer); timer = null; sync();
    warteBisRuhig().then(function () {
      weiterleiten = true;
      try {
        if (t.form && t.form.requestSubmit) t.form.requestSubmit(t);
        else location.href = t.href || ROOT + 'checkout';
      } catch (err) {
        location.href = ROOT + 'checkout';
      }
      setTimeout(function () { weiterleiten = false; }, 1000);
    });
  }, true);

  window.SZZugabe = {
    config: cfg,
    state: function () {
      var vorher = aenderungen;
      return json('cart.js').then(function (cart) {
        var s = stand(cart);
        // Laeuft gerade eine Aenderung oder kam waehrend der Abfrage eine dazu,
        // waere dieser Stand schon veraltet
        if (inArbeit === 0 && vorher === aenderungen) melden(s);
        return s;
      });
    },
    // Hinzufuegen: Vorpruefung immer am aktuellen Warenkorb. Der Stand wird
    // angezeigt, sobald der Shop die Dose angenommen hat. Ein Abgleich laeuft
    // danach im Hintergrund (falls parallel in einem anderen Tab etwas passiert).
    add: function (id) {
      var key = String(Number(id));
      return nacheinander(function () {
        return json('cart.js').then(function (cart) {
          var s = stand(cart);
          if (s.frei < 1) throw new Error(s.erlaubt === 0
            ? 'Ab ' + euro(cfg.tiers[0]) + ' Warenwert kannst du dir die erste Dose aussuchen.'
            : 'Alle Plätze sind belegt. Nimm eine Dose heraus oder füll den Warenkorb weiter.');
          var props = {};
          props[cfg.property] = cfg.propertyValue;
          return json('cart/add.js', { items: [{ id: Number(id), quantity: 1, properties: props }] }).then(function () {
            var neu = {};
            for (var k in s) neu[k] = s[k];
            neu.jeSorte = {};
            for (var v in s.jeSorte) neu.jeSorte[v] = s.jeSorte[v];
            neu.jeSorte[key] = (neu.jeSorte[key] || 0) + 1;
            neu.gewaehlt += 1;
            neu.frei = Math.max(0, neu.erlaubt - neu.gewaehlt);
            melden(neu);
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
            nacheinander(function () { return json('cart.js').then(abgleichen); })
              .catch(function (err) {
                if (window.console) console.warn('[Schmorzeit-Zugabe]', err);
                schedule(true);
              });
            return neu;
          }, function (err) {
            // Abgebrochen oder Netzfehler: Die Dose kann trotzdem angelegt sein,
            // deshalb auf jeden Fall abgleichen
            schedule(true);
            throw err;
          });
        });
      });
    },
    // Entfernen: Zeile im aktuellen Warenkorb suchen, um eine verringern.
    // change.js liefert den neuen Warenkorb zurueck, der direkt abgeglichen
    // wird. Scheitert change.js (Zeile inzwischen geaendert), einmal neu versuchen.
    remove: function (id) {
      return nacheinander(function () {
        function versuch(cart, nochmal) {
          var line = cart.items.filter(function (it) { return it.variant_id === Number(id); })[0];
          if (!line) {
            if (nochmal) return json('cart.js').then(function (c) { return versuch(c, false); });
            var s0 = stand(cart); melden(s0); return s0;
          }
          return json('cart/change.js', { id: line.key, quantity: line.quantity - 1 }).then(function (neu) {
            // Abgleichen statt nur anzeigen: Hat sich die Zeile zwischen Lesen und
            // Aendern geaendert, koennte die gesetzte Menge sonst zu hoch sein
            return abgleichen(neu).then(function (s) {
              document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
              return s;
            });
          }, function (err) {
            if (nochmal) return json('cart.js').then(function (c) { return versuch(c, false); });
            throw err;
          });
        }
        return json('cart.js').then(function (c) { return versuch(c, true); });
      });
    },
    last: function () { return letzterStand; }
  };

  function start() {
    try {
      var t = sessionStorage.getItem(MERK);
      if (t) { sessionStorage.removeItem(MERK); hinweis(t); }
    } catch (e) {}
    if (noetig()) sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('on:bfcache:load-restore', function () { schedule(true); });
  // Zurueck-Taste (Seite aus dem Browser-Zwischenspeicher) und Rueckkehr aus
  // einem anderen Tab: Der Warenkorb kann sich dort geaendert haben.
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(true); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(); });
  window.addEventListener('focus', function () { schedule(); });
  // Ein anderer Tab hat Dosen in den Warenkorb gelegt
  window.addEventListener('storage', function (e) {
    if (e.key === MERK_DOSEN && e.newValue) { hatDosen = true; schedule(); }
  });
})();
